<script setup lang="ts">
definePageMeta({
  middleware: 'auth-check',
});
useAppMeta({
  title: '設定',
});
</script>

<template>
  <NuxtPage />
</template>
